import { GRID_BREAKPOINTS } from '../../../common/device/breakpointConstants';

export type GridSizeDefinition = {
    size: number;
    breakpoint: number;
    name: string;
};

// if these are changed, also make sure to update GridSizeBodyClass.js,
// which sets the grid size class on initial render
export const GRID: Record<string, GridSizeDefinition> = {
    // FIXME-MOBILE - The grid size property should be independent of whether we're on mobile or not.
    MOBILE: { size: 10, breakpoint: GRID_BREAKPOINTS.MOBILE, name: 'mobile' },
    SMALL: { size: 8, breakpoint: GRID_BREAKPOINTS.SMALL, name: 'small' },
    MEDIUM: { size: 9, breakpoint: GRID_BREAKPOINTS.MEDIUM, name: 'medium' },
    LARGE: { size: 10, breakpoint: GRID_BREAKPOINTS.LARGE, name: 'large' },
};

export const GRID_SIZE_LIST: GridSizeDefinition[] = [
    { size: 10, breakpoint: GRID_BREAKPOINTS.MOBILE, name: 'mobile' },
    { size: 8, breakpoint: GRID_BREAKPOINTS.SMALL, name: 'small' },
    { size: 9, breakpoint: GRID_BREAKPOINTS.MEDIUM, name: 'medium' },
    { size: 10, breakpoint: GRID_BREAKPOINTS.LARGE, name: 'large' },
];

// screen display points reference
export const GRID_SIZE_LIST_TOUCH_DEVICE: GridSizeDefinition[] = [
    { size: 10, breakpoint: GRID_BREAKPOINTS.MOBILE, name: 'mobile' },
    // 9.7" iPads
    { size: 8, breakpoint: GRID_BREAKPOINTS.SMALL, name: 'small' },
    // 12.9" iPads
    { size: 9, breakpoint: GRID_BREAKPOINTS.MEDIUM, name: 'medium' },
    // Very large tablets/touch devices
    { size: 10, breakpoint: GRID_BREAKPOINTS.LARGE, name: 'large' },
];

export const GRID_RESIZE = 'GRID_RESIZE';
